export default __webpack_public_path__ + "static/media/signup-banner.c628e66d.png";